import DefaultMapper, { addCustomMethods, mapId, mapIdInList } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class WalletAccountMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/wallets/accounts';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
		options.body = JSON.stringify(params.data);
	}

	prepareDeleteOne({ type, resource, params, options, mappedResource }) {
		options.method = 'DELETE';
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}`;
		options.body = JSON.stringify(params.data);
	}

	finishGetList({ result }) {
		return mapIdInList(super.finishGetList({ result }), 'walletAccountId');
	}

	finishGetOne({ type, resource, params, options, mappedResource, result }) {
		return mapId(super.finishGetOne({ result }), 'walletAccountId');
	}

	/**
	 * If the API doesn't return anything, it's the dataProvider's job to return the input data.
	 * Since we land here in case of a 2XX - we can simply override the empty response.
	 */
	finishCreate({ type, resource, params, options, mappedResource, result }) {
		return { data: { id: params.id, description: params.description } };
	}

	finishDeleteOne({ type, resource, params, options, mappedResource, result }) {
		return { data: { id: params.id, description: params.description } };
	}
}

export default WalletAccountMapper;
